import React, { useMemo } from 'react';

export function LicenseStatusInfoText({ certificateInfo, renewalInfo, show }) {
  const text = useMemo(() => {
    if (certificateInfo)
      return `Active License - Expiry date ${certificateInfo.expirationDate}`;
    if (renewalInfo)
      return `Renewal application - Submitted ${renewalInfo.applicationDate}`;

    return null;
  }, [certificateInfo, renewalInfo]);

  if (!show || !text) return null;

  return <div css="margin-bottom: 8px;">{text}</div>;
}
